import { KeyboardArrowDown } from '@mui/icons-material';
import SquareIcon from '@mui/icons-material/Square';
import { Box, ListItemButton, ListItemIcon, ListItemText, Stack } from '@mui/material';
import { useState } from 'react';
import ColorConstants from '../../../../../../defaults/ColorConstants';

export function ListItemsDivided({listItems}){
  if(listItems?.length){
    return(
      <>
      {listItems?.map((item, index) => (
        <ListItemButton
          key={index}
          sx={{ py: 0, minHeight: 32 }}
        >
          <ListItemIcon sx={{ color: 'inherit' }}>
            <SquareIcon sx={{color: item.color}} />
          </ListItemIcon>
          <ListItemText
            primary={item.label}
            primaryTypographyProps={{ fontSize: 14, fontWeight: 'medium' }}
          />
        </ListItemButton>
      ))}
      </>
    )
  } else {
    return (<></>);
  }
}

export function ListItemButtonForEach({seriesData}){
  let leftSide = seriesData;
  let rightSide = [];
  if(seriesData?.length){
    if(seriesData.length > 10){
      const m = Math.ceil(seriesData.length/2);
      [leftSide,rightSide] = [seriesData.slice(0,m), seriesData.slice(m, seriesData.length)];
    }
  } 

  if(leftSide?.length && rightSide?.length){
    return(
      <Stack direction="row">
        <Stack direction="column">
          <ListItemsDivided listItems={leftSide} />
        </Stack>
        <Stack direction="column">
          <ListItemsDivided listItems={rightSide} />
        </Stack>
      </Stack>
    )
  } else {
    return (
      <Stack direction="column">
        <ListItemsDivided listItems={seriesData} />
      </Stack>
    )
  }

  
}

export function ListItemForEach ({series}) {
  const [open, setOpen] = useState(true);
  return (
    <Box sx={{ paddingBottom: open ? 2 : 0 }}>
      <ListItemButton
        alignItems="flex-start"
        id={series.id}
        onClick={() => setOpen(!open)}
        sx={{
          px: 3, //padding right and padding left
          pt: 1, // padding top
          pb: 1, // padding bottom
          marginTop: 6,
          svg: {opacity: 1},
          borderBottom: `${ColorConstants.BlueAlien} 1px solid`,
          '&:hover, &:focus': { '& svg': { opacity: 1 } },
        }}
      >
        <ListItemText
          primary={series.id}
          primaryTypographyProps={{
            fontSize: 15,
            fontWeight: 'medium',
            lineHeight: '20px',
            marginBottom: '2px',
          }}
          sx={{ my: 0 }}
        />
        <KeyboardArrowDown
          sx={{
            marginRight: -1,
            opacity: 0,
            transform: open ? 'rotate(-180deg)' : 'rotate(0)',
            transition: '0.2s',
          }}
        />
      </ListItemButton>
      {(open && series?.data) &&
        <Stack direction="row">
          <ListItemButtonForEach seriesData={series?.data} />
        </Stack>
      }
    </Box>
  )
}

export default function Legend({series}) {
      return(
        <Stack direction="row" spacing={1}>
        {series?.map((series, index) => {
          return (<ListItemForEach series={series} key={index} />)
        })}
        </Stack>
      );
}